import React, { useContext, useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { FaChevronLeft } from 'react-icons/fa'
import urls from '../../../../utils/constants/urls'
import { useLocation } from 'react-router-dom'

import { DataContext } from '../DataContext'

export default () => {
    const {
        returnToList,
        submissionState,
        isReview,
        viewOnly,
        formType,
    } = useContext(DataContext)
    const location = useLocation()
    const { state: locationState } = location
    const history = useHistory()

    const onClick = useCallback(() => {
        returnToList()
            .then(() => {
                history.push({
                    pathname: urls.manageSampleResults,
                    state: {
                        from:
                            isReview || viewOnly
                                ? (locationState && locationState.from) ||
                                  'submitted'
                                : 'inProgress',
                    },
                })
            })
            .catch(() => {})
    }, [returnToList, locationState])

    const clearinghouseNumber = useMemo(() => {
        if (formType && formType.Link === 'merge') {
            if (
                submissionState &&
                submissionState.uploadFacilityMerge &&
                submissionState.uploadFacilityMerge.length
            ) {
                const primaryFacility = submissionState.uploadFacilityMerge.find(
                    x =>
                        x.IsPrimary === true ||
                        x.IsPrimary === 'true' ||
                        x.IsPrimary === 1
                )
                return (
                    (primaryFacility && primaryFacility.ClearinghouseNumber) ||
                    ''
                )
            }
        } else {
            if (
                submissionState &&
                submissionState.facility &&
                submissionState.facility.ClearinghouseNumber
            ) {
                return submissionState.facility.ClearinghouseNumber
            }
            if (location.state && location.state.clearinghouse) {
                return location.state.clearinghouse
            }
        }
        return ''
    }, [submissionState, location, formType])

    return (
        <nav
            className="breadcrumb breadcrumbAlignment"
            aria-label="breadcrumbs"
        >
            <ul>
                <li>
                    <div className="link" onClick={onClick}>
                        <span className="icon is-small">
                            <FaChevronLeft />
                        </span>
                        <span>Return to Submissions List</span>
                    </div>
                    <div className="clearinghouseNumber">
                        {submissionState && submissionState.upload ? (
                            <span style={{ userSelect: 'text' }}>
                                <b>
                                    {formType.Link === 'merge'
                                        ? `Primary Clearinghouse Number`
                                        : `Clearinghouse Number`}
                                    :
                                </b>{' '}
                                {clearinghouseNumber}
                            </span>
                        ) : (
                            <span></span>
                        )}
                    </div>
                </li>
            </ul>
        </nav>
    )
}
